import { apiSlice } from "./apiSlice";
import domain from "../util/domain";
const GRAPHICS_URL = `${domain}/api/graphics`;

export const graphicsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAllGraphicsValueLabel: builder.query({
      query: () => ({
        url: `${GRAPHICS_URL}/valuelabel`,
      }),
      providesTags: ["Graphics"],
    }),
  }),
});
export const { useGetAllGraphicsValueLabelQuery } =
  graphicsApiSlice;
